import React from 'react';
import PropTypes from 'prop-types';
import { getWord } from 'utils/tenant';
import css from './StaffEmailPreferences.scss';
import Icon from 'SF/MaterialIcon';
import Switch from 'common/Switch';

const StaffEmail = ({isChecked, email, handleOptInChange, id, isError, customLabel}) => {
    return (
        <div className={css['staff-email']}>
            <label htmlFor={id} className={css['label-text']}>
               {isError && <Icon icon="error" className={css['icon-error']}/>}
               Send to my {getWord(customLabel)}:
            </label>
            <Switch id={id}
                    checked={isChecked}
                    onChange={handleOptInChange}
                    aria-label={`Send to my ${getWord(customLabel, true)}: ${email}`} />
            <p className={css['email']} data-testid={id}>{email}</p>
        </div>
    );
};

StaffEmail.propTypes = {
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    isError: PropTypes.bool,
    customLabel: PropTypes.string,
    handleOptInChange: PropTypes.func,
    isChecked: PropTypes.bool,
};

export default StaffEmail;
